import React from "react";
import { MusicHallAccountingContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import queryString from "query-string";
import { portalService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import * as XLSX from "xlsx";
import moment from "moment";
import { Displays, Tables, Inputs } from "components";

class MusicHallAccountingContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    const query = this.buildQueryString();
    this.fetchData(query);
  }

  fetchData = async (query) => {
    const { start_date, group_by } = queryString.parse(query);
    const isMonth = !group_by || group_by === "month";
    const year = moment(start_date).format("YYYY");
    let resArr = await Promise.all([
      isMonth
        ? portalService.GET_ACCOUNTING_REPORT_BY_ROOM_LIST(
            `?month=${moment(start_date).format("YYYY-MM")}`
          )
        : portalService.GET_ACCOUNTING_REPORT_BY_MONTH_LIST(`?year=${year}`),
      // ยอดกลับรายการจากการลบการจอง ในช่วงเดียวกับรายงาน ให้บัญชีรู้ว่ายอดที่ลดลงมาจากไหน
      portalService.GET_ACCOUNTING_LIST(
        `?booking_deleted=true&pagination=false&sort=transaction_date${
          isMonth
            ? `&month=${moment(start_date).format("YYYY-MM")}`
            : `&start_date=${year}-01-01&end_date=${year}-12-31`
        }`
      ),
    ]);
    if (resArr) {
      this.setState({
        dataBookingDeletedList: resArr[1]?.data?.docs || [],
        dataAccountingByRoomList: resArr[0].data,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  // QUERY FLOW
  // =========================================
  // =========================================
  buildQueryString = (additionalParams = {}) => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    const defaultQuery = {
      // start_date: moment().startOf("month").format("YYYY-MM-DD"),
      // end_date: moment().endOf("month").format("YYYY-MM-DD"),
    };
    const finalParams = {
      ...defaultQuery,
      ...urlParams,
      ...additionalParams,
    };
    const cleanParams = Object.entries(finalParams)
      .filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    const query = `?${Object.entries(cleanParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&")}`;
    router.navigate(`${ROUTE_PATH.MUSIC_HALL_BOOKING_ACCOUNTING}${query}`);
    return query;
  };
  handleFilterKeyword = (e) => {
    const queryParams =
      typeof e === "string" ? queryString.parse(e.replace("?", "")) : e;
    this.handleJoinQuery(queryParams);
  };
  handlePageClick = (e) => {
    this.handleJoinQuery({ page: e.selected + 1 });
  };
  handleJoinQuery = (additionalQuery) => {
    const query = this.buildQueryString(additionalQuery);
    this.setState({
      isLoading: true,
    });
    this.fetchData(query);
  };

  handleExport = async () => {
    const { dataAccountingByRoomList } = this.state;
    this.setState({
      isBgLoading: true,
    });

    const { columns, rows } = dataAccountingByRoomList;

    // สร้าง room columns (ไม่รวม type, label, total)
    const roomColumns = columns.filter(
      (col) => !["type", "label", "total"].includes(col.key)
    );

    // หา row ตาม type
    const getRowByType = (type) => rows.find((r) => r.type === type) || {};

    // Format number
    const formatNumber = (num) => {
      if (num === null || num === undefined || num === "" || num === 0) return "";
      return num;
    };

    // สร้างข้อมูลสำหรับแต่ละ section
    const sections = [
      {
        type: "A",
        title: "รับล่วงหน้า ยกมา",
        titleRow: getRowByType("A"),
        subRows: [{ label: "เงินจองห้องล่วงหน้า", data: getRowByType("A") }],
      },
      {
        type: "B",
        title: "ยอดรับจากการโอน",
        titleRow: getRowByType("B"),
        subRows: [{ label: "เงินจองห้องล่วงหน้า", data: getRowByType("B") }],
      },
      {
        type: "C",
        title: "รายได้รับรู้แล้ว",
        titleRow: {
          total: (getRowByType("C1").total || 0) + (getRowByType("C2").total || 0),
        },
        subRows: [
          { label: "ค่าเช่าห้อง", data: getRowByType("C1") },
          { label: "ค่าบริการเพิ่ม", data: getRowByType("C2") },
        ],
      },
      {
        type: "E",
        title: "เงินรับล่วงหน้า(คงเหลือ)",
        titleRow: getRowByType("E"),
        subRows: [{ label: "เงินจองห้องล่วงหน้า", data: getRowByType("E") }],
      },
    ];

    // สร้าง header row
    const headerRow = ["", "รายการ", "รวม", ...roomColumns.map((col) => col.label)];

    // สร้าง data rows
    let ws_data = [headerRow];

    sections.forEach((section) => {
      // Title Row
      const titleRowData = [
        section.type,
        section.title,
        !["B", "E"].includes(section.type) ? formatNumber(section.titleRow.total) : "",
        ...roomColumns.map((col) =>
          !["B", "E"].includes(section.type) ? formatNumber(section.titleRow[col.key]) : ""
        ),
      ];
      ws_data.push(titleRowData);

      // Sub Rows
      section.subRows.forEach((subRow) => {
        const subRowData = [
          "",
          subRow.label,
          formatNumber(subRow.data?.total),
          ...roomColumns.map((col) => formatNumber(subRow.data?.[col.key])),
        ];
        ws_data.push(subRowData);
      });

      // Spacer Row
      ws_data.push([]);
    });

    // สร้าง column widths
    const columnWidths = [
      { wch: 5 },  // type
      { wch: 25 }, // รายการ
      { wch: 12 }, // รวม
      ...roomColumns.map(() => ({ wch: 15 })),
    ];

    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = columnWidths;

    XLSX.utils.book_append_sheet(wb, ws, "Accounting Report");
    XLSX.writeFile(
      wb,
      `music-hall-accounting-${moment()
        .tz("Asia/Bangkok")
        .format("DD-MM-YYYY")}.xlsx`
    );
    
    this.setState({
      isBgLoading: false,
    });
  };

  render() {
    const { router, authenRedux } = this.props;
    const {
      isBgLoading,
      isLoading,
      dataAccountingByRoomList,
      dataBookingDeletedList,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find(
          (e) => e.menu_key === "music-hall-booking"
        );
    return (
      <MusicHallAccountingContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          <Inputs.InputFilter
            theme_standard_input_filter
            dataFilter={dataFilter(router.location?.search)}
            btnLabel="ค้นหา"
            onQueryFilter={this.handleFilterKeyword}
            onExport={
              permission &&
              (permission.is_export || permission.is_export_condition)
                ? () => this.handleExport(permission)
                : false
            }
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <Tables.TableAccounting
              theme_standard
              data={dataAccountingByRoomList}
            />
            {dataBookingDeletedList && dataBookingDeletedList.length > 0 && (
              <div className="booking_deleted_layout">
                <div className="booking_deleted_title">
                  รายการกลับรายการจากการลบการจอง
                </div>
                <div className="booking_deleted_desc">
                  แอดมินลบการจองที่มียอดเงินแล้ว ระบบลงยอดติดลบ ณ วันที่ลบ
                  (ยอดเดิมยังอยู่ในเดือนที่รับเงิน/รับรู้รายได้)
                  ยอดเหล่านี้รวมอยู่ในรายงานด้านบนแล้ว
                </div>
                <Tables.Standard
                  columns={bookingDeletedColumns()}
                  data={dataBookingDeletedList}
                />
              </div>
            )}
          </>
        )}
      </MusicHallAccountingContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "group_by",
      filter: {
        fieldQuery: "group_by",
        type: "dateGroup",
        initialValues: {
          level1: !initialValues["group_by"]
            ? "month"
            : initialValues["group_by"],
          level2: !initialValues["group_by"]
            ? new Date()
            : initialValues["group_by"] === "month"
            ? new Date(initialValues["start_date"])
            : new Date(initialValues["start_date"]),
        },
        options: [
          { label: "Year", value: "year" },
          { label: "Month", value: "month" },
        ],
      },
    },
  ];
};

// ประเภทเดียวกับแถวในรายงานด้านบน
const RENDER_TRANSACTION_TYPE = (type) =>
  ({
    B: "B ยอดรับจากการโอน",
    C1: "C1 รายได้รับรู้ ค่าห้อง",
    C2: "C2 รายได้รับรู้ ค่าบริการเพิ่มเติม",
  })[type] || type;

const bookingDeletedColumns = () => [
  {
    Header: <div style={{ textAlign: "left" }}>วันที่ลบ</div>,
    accessor: "transaction_date",
    Cell: (props) =>
      moment(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>ห้อง</div>,
    accessor: "room_name_th",
    Cell: (props) => props.value || "-",
  },
  {
    Header: <div style={{ textAlign: "left" }}>ผู้จอง</div>,
    accessor: "booking",
    Cell: (props) =>
      props.value
        ? `${props.value.booker_first_name || ""} ${
            props.value.booker_last_name || ""
          }`
        : "-",
  },
  {
    Header: <div style={{ textAlign: "left" }}>วันจัดงาน</div>,
    accessor: "booking.booking_date",
    Cell: (props) =>
      props.value
        ? moment(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY")
        : "-",
  },
  {
    Header: <div style={{ textAlign: "left" }}>ประเภท</div>,
    accessor: "transaction_type",
    Cell: (props) => RENDER_TRANSACTION_TYPE(props.value),
  },
  {
    Header: <div style={{ textAlign: "right" }}>ยอด</div>,
    accessor: "amount",
    Cell: (props) => (
      <div style={{ textAlign: "right" }}>
        {Number(props.value || 0).toLocaleString()}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>ลบโดย</div>,
    accessor: "created_by_id",
    Cell: (props) => props.value?.username || "-",
  },
  {
    Header: <div style={{ textAlign: "left" }}>หมายเหตุ</div>,
    accessor: "note",
    Cell: (props) => props.value || "-",
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MusicHallAccountingContainer));

// {
//   /* <Tables.TableBookingReserve theme_standard /> */
// }
// {
//   /* <div className="button_status">
//           <div className="update_button">
//             <Buttons.BgStandard label="Update" />
//           </div>
//           <div className="status_info_row">
//             <Displays.StatusShowInfo
//               color="#2EB117"
//               status="ยืนยันนัด Detail + Slip Approved "
//             />
//             <Displays.StatusShowInfo
//               color="#FF9D00"
//               status="รอยืนยัน: Detail Approved, Wait for Slip"
//             />
//             <Displays.StatusShowInfo
//               color="#FFF500"
//               status="รอยืนยัน: Waiting for approved"
//             />
//             <Displays.StatusShowInfo color="#FF0000" status="ยกเลิก: Cancel " />
//           </div>
//         </div> */
// }
